import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class KeyboardListenerService {
	//region Variables
	public readonly currentTyped = fromEvent<KeyboardEvent>(window, 'keydown').pipe(
		filter(
			(event) =>
				!event.altKey &&
				!event.shiftKey &&
				!event.ctrlKey &&
				!event.metaKey &&
				event.key !== 'ArrowDown' &&
				event.key !== 'ArrowUp' &&
				event.key !== 'ArrowLeft' &&
				event.key !== 'ArrowRight'
		),
		map((keyboardEvents) => keyboardEvents.key)
	);

	public readonly onArrowTyped = fromEvent<KeyboardEvent>(window, 'keydown').pipe(
		filter(
			(event) =>
				event.key === 'ArrowDown' ||
				event.key === 'ArrowUp' ||
				event.key === 'ArrowLeft' ||
				event.key === 'ArrowRight'
		)
	);
	//endregion
}
